module.exports = __webpack_public_path__ + "img/nt117-06-86-1.prt.64916ee5.jpg";